'use es6';

import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const renderListItems = ({
  hasFormsWriteAccess = true,
  onCreateClick = () => {},
  onCloneClick = () => {},
  onPagesClick = () => {},
  onEditorClick = () => {},
  onViewSubmissionsClick = () => {},
  guid = ''
}) => /*#__PURE__*/_jsxs(UIList, {
  children: [/*#__PURE__*/_jsx(UILink, {
    "data-selenium": "form-actions-dropdown-view-submissions",
    disabled: !hasFormsWriteAccess,
    onClick: () => onViewSubmissionsClick(guid),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('viewSubmissions')
    })
  }), /*#__PURE__*/_jsx(UILink, {
    "data-selenium": "form-actions-dropdown-form-clone",
    disabled: !hasFormsWriteAccess,
    onClick: () => onCloneClick(guid),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('clone')
    })
  }), /*#__PURE__*/_jsx(UILink, {
    "data-selenium": "form-actions-dropdown-view-pages",
    disabled: !hasFormsWriteAccess,
    onClick: onPagesClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('pages')
    })
  }), /*#__PURE__*/_jsx(UILink, {
    "data-selenium": "form-actions-dropdown-go-to-editor",
    disabled: !hasFormsWriteAccess,
    onClick: onEditorClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('editor')
    })
  }), /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(UILink, {
    "data-selenium": "form-actions-dropdown-form-create",
    disabled: !hasFormsWriteAccess,
    onClick: onCreateClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('create')
    })
  })]
});
const FormActionsDropdown = props => /*#__PURE__*/_jsxs(UIFlex, {
  className: "m-bottom-4",
  align: "center",
  justify: "between",
  gap: 10,
  children: [/*#__PURE__*/_jsx(UIBox, {
    grow: 1,
    children: /*#__PURE__*/_jsx(UIDropdown, {
      "data-selenium": "form-actions-dropdown",
      buttonSize: "small",
      buttonClassName: "m-right-6",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('actions')
      }),
      children: renderListItems(props)
    })
  }), /*#__PURE__*/_jsx(UIBox, {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('rawHTMLWarning.description')
      })
    })
  })]
});
export default FormActionsDropdown;